var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6373 16.2115H3.68457V23.9995H7.6373V16.2115Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0968 11.762H11.144V24H15.0968V11.762Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5567 6.75537H18.604V24H22.5567V6.75537Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50336 12.9565L1.44336 12.5867C7.7718 11.1974 13.4604 7.74737 17.6173 2.77759L17.9072 3.01571C13.6912 8.05472 7.92142 11.5513 1.50336 12.9565Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8213 1.52512L20.4244 0L19.5147 4.68112L15.8213 1.52512Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.19d325ab3948c6ae9c27b963bc175b32.svg";
export { ForwardRef as ReactComponent };